import {create} from "zustand";

type CatalogFiltersDrawerStore = {
    opened: boolean;
    actions: {
        openModal: () => void;
        closeModal: () => void;
    };
};
export const useCatalogFiltersDrawer = create<CatalogFiltersDrawerStore>((set) => ({
    opened: false,
    actions: {
        openModal: () => set({opened: true}),
        closeModal: () => set({opened: false}),
    }
}));
